import { baseApi, STATISTICS_TAG, AUTH_TAG } from '@/shared';
import { statisticsAdapter } from '../utils/helpers/adapter';

import type { TGetStatisticsParams, TStatistics } from './types';

export const statsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getStatistics: build.query<TStatistics[], TGetStatisticsParams>({
      query: (params: TGetStatisticsParams) => ({
        url: '/admin/statistics/summary',
        params: {
          created_from: params.createdFrom,
          created_to: params.createdTo,
          shop_id: params.shopId,
        },
      }),
      transformResponse: statisticsAdapter,
      providesTags: [STATISTICS_TAG, AUTH_TAG],
    }),

  }),
});

export const {
  useGetStatisticsQuery,
} = statsApi;
